<div class="flex flex-col flex-1 min-h-0 h-full w-full">
@if (displayChips && showBlueprints) {
  <div class="pb-2 shrink-0">

    <mat-chip-listbox
      class="template-filter-chips"
      [hideSingleSelectionIndicator]="true"
      [value]="selectedTemplateFilter"
      (change)="setTemplateFilter($event.value)"
      [attr.aria-label]="'Blueprint filter' | translate"
      >
  
      <mat-chip-option 
        value="all"
        (selectionChange)="keepSelected($event)">
        {{ 'All' | translate }}
      </mat-chip-option>
  
      <mat-chip-option 
        value="default"
        (selectionChange)="keepSelected($event)">
        <mat-icon svgIcon="community" class="icon-size [--icon-size:16px] translate-y-0.5 mr-1"/>
        {{ 'Organisation' | translate }}
      </mat-chip-option>
  
      @if (showBlueprints) {
        <mat-chip-option 
          value="blueprints"
          (selectionChange)="keepSelected($event)">
          <mat-icon svgIcon="book-stack" class="icon-size [--icon-size:16px] translate-y-0.5 mr-1"/>
          {{ 'Personal' | translate }}
        </mat-chip-option>
      }
    </mat-chip-listbox>
  </div>
}


<div class="bg-surface-bright rounded-lg border border-[#CFCFCF]
       w-full flex-1 min-h-0 flex flex-col overflow-hidden"
>
  

  <ng-container
    *ngTemplateOutlet="
      templateList;
      context: { templates: filteredTemplates }
    ">
  </ng-container>
</div>
</div>

<ng-template #templateList let-templates="templates">
  <div #templateListScroll class="px-2 overflow-y-auto flex-1 min-h-0 flex flex-col">
    @if (templates.length > 0) {
      <div *ngFor="let template of templates; let last = last" 
        class="transition-colors px-4"
        [ngClass]="isApproved(template) || isDisabled(template) ? 'cursor-default' : 'hover:bg-surface-container-low cursor-pointer'"
        [attr.data-testid]="'dialog-template-item-' + template.id"
        (click)="toggleSelection(template)">
        <div class="flex items-center gap-2 min-h-16 border-surface-container py-1" [class.border-b]="!last">
          <!-- Title -->
          <div class="flex-1 min-w-0 flex flex-col md:flex-row md:items-center gap-1 md:gap-2">

            <div
              class="w-full min-w-0 flex flex-col justify-center"
              [class.opacity-20]="isApproved(template)"
              [attr.data-testid]="isApproved(template) ? 'template-approved-title' : null">

              <h3
                class="body-medium md:body-large text-on-surface break-words"
                [ngClass]="isDisabled(template) && !isApproved(template)
                  ? 'text-on-surface/50'
                  : 'text-on-surface'">
                {{ template.title }}
              </h3>
            </div>
          </div>

          <div class="flex shrink-0 items-center gap-1">
            @if (!isApproved(template) && showBlueprints && isOrganisationTemplate(template.type)) {
              <span
                class="inline-flex cursor-default items-center justify-center rounded-[4px] border border-surface-varient bg-primary-99 px-1 py-0.5 outline-none focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-offset-2 focus-visible:outline-primary"
                tabindex="0"
                role="img"
                data-testid="organisation-blueprint-indicator"
                [attr.aria-label]="'Organisation blueprint' | translate"
                [appTooltip]="'Organisation blueprint' | translate"
                appTooltipPosition="above"
                appTooltipAlign="end"
                (click)="preventRowSelection($event)"
                (keydown)="preventRowSelection($event)">
                <img
                  src="assets/organisation-blueprint.svg"
                  alt=""
                  width="14"
                  height="14"
                  class="pointer-events-none block" />
              </span>
            }

            @if (isApproved(template)) {
              <span
                class="shrink-0 px-2.5 py-0.5 rounded-2xl border body-small text-center text-secondary-30 bg-secondary-98 border-secondary-80"
                data-testid="template-approved-badge">
                {{ 'Approved' | translate }}
              </span>
            } @else {
              @if (singleSelection) {
                <mat-radio-button
                  [checked]="isSelected(template) || isDisabled(template)"
                  [disabled]="isDisabled(template)"
                  color="primary"
                  class="shrink-0 !mr-1 pointer-events-none"
                  [attr.aria-label]="template.title"
                  data-testid="template-radio"
                  (change)="toggleSelection(template)">
                </mat-radio-button>
              } @else {
                <mat-checkbox
                  [checked]="isSelected(template) || isDisabled(template)"
                  [disabled]="isDisabled(template)"
                  color="primary"
                  class="shrink-0 !mr-1 pointer-events-none">
                </mat-checkbox>
              }
            }
          </div>
        </div>
      </div>
      <div *ngIf="!templates || templates.length === 0" class="text-center py-8">
        <p class="body-large text-on-surface-variant">{{ filteredEmptyStateLabel | translate }}</p>
      </div>
    }
    @else {
      @if (loading) {
        <div class="flex flex-col flex-1 min-h-0" aria-hidden="true" data-testid="blueprint-list-skeleton">
          @for (width of loadingSkeletonWidths; track $index) {
            <div class="px-4">
              <div
                class="flex items-center gap-2 min-h-16 border-surface-container py-1"
                [class.border-b]="$index < loadingSkeletonWidths.length - 1">
                <div class="flex-1 min-w-0">
                  <app-skeleton [width]="width" height="1rem"></app-skeleton>
                </div>
                <app-skeleton width="1.25rem" height="1.25rem" rounded="sm"></app-skeleton>
              </div>
            </div>
          }
        </div>
      }
      @else {
        <div class="flex flex-col items-center justify-center flex-1 min-h-0 py-8">
          <img src="assets/folder_empty.svg" alt="" class="h-20 w-20 mb-4 opacity-70" />
          <div class="text-primary text-center">
            <p class="title-medium">{{ filteredEmptyStateLabel | translate }}</p>
          </div>
        </div>
      }
    }

  </div>
</ng-template>


